module.exports = __webpack_public_path__ + "495d10402112e8ba84068d613724ceb3.jpg";